<script>
import Vue from "vue";
import vClickOutside from "v-click-outside";
import ProductPickerPanel from "./core/ProductPickerPanel.vue";
import ByCondition from "./plugins/ByCondition.vue";
import ByProduct from "./plugins/ByProduct.vue";
import BySku from "./plugins/BySku.vue";
import "./sheet/main.scss";

Vue.use(vClickOutside);

let renderTimer = 0;

export default {
  name: "ProductPicker",

  props: {
    option: {
      type: [Object]
    }
  },

  computed: {
    plugins() {
      return {
        conditions: {
          component: ByCondition,
          id: "conditions",
          label: this.$t("Root.Picker.ByCondition"),
          supportSingleMode: false
        },
        product: {
          component: ByProduct,
          id: "product",
          label: this.$t("Root.Picker.Byproduct"),
          supportSingleMode: true
        },
        sku: {
          component: BySku,
          id: "sku",
          label: this.$t("Root.Picker.BySKU"),
          supportSingleMode: true
        }
      };
    }
  },

  render(h) {
    const ALL_SUPPORT_PLUGINS = Object.keys(this.plugins);
    let {
      plugins = "conditions product sku",
      defaultActive,
      labelWidth,
      formSize,
      singleMode = false,
      required = false,
      disabled = false,
      hiddenSelect = false,

      initData = {},
      setting = {}
    } = this.option || {};

    // 防止错误的plugins
    plugins = plugins.split(" ").filter(id => ALL_SUPPORT_PLUGINS.includes(id));

    // 如果是单选模式 筛选出支持单选模式的plugin
    if (singleMode) {
      plugins = plugins.filter(id => this.plugins[id].supportSingleMode);
    }

    // 默认激活的plugin
    defaultActive = plugins.includes(defaultActive)
      ? defaultActive
      : plugins[0];

    const childSlots = plugins.map(pluginID => {
      const { id, label, component, supportSingleMode } =
        this.plugins[pluginID];

      renderTimer++;

      return h(component, {
        props: {
          // v2: 将插件对应的配置项直接解构为每一个具名的 prop ，该prop可以直接在每一个插件中定义
          ...(setting[id] || {}),

          // v1： 兼容性考虑 ， setting字段也会继续保留 将在后续中不断的替换掉
          setting: setting[id] || undefined,

          // Others
          id,
          label,
          initData: initData[id] || null,
          singleMode,
          supportSingleMode,
          required
        },
        key: renderTimer
      });
    });

    return h(
      ProductPickerPanel,
      {
        props: {
          defaultActive,
          labelWidth,
          formSize,
          disabled,
          hiddenSelect
        },
        ref: "panel"
      },
      childSlots
    );
  },

  methods: {
    // 此方法将穿透给子组件 ProductPickerPanel
    submit() {
      return this.$refs.panel.submit();
    }
  }
};
</script>
